module.exports = __webpack_public_path__ + "img/clean.f03e5c3a.png";